module.exports = __webpack_public_path__ + "static/media/slider-small-3.f994bc61.jpg";